import { defineMessages } from 'react-intl';

export default defineMessages({
  CONNECTIONS_COUNT: {
    defaultMessage: '{count, plural, one {# connexion} other {# connexions}}',
  },
});
